import { Flex } from "@chakra-ui/react";
import { TaxSectionProps } from ".";
import { InputButton } from "../../components/Forms/InputButton";
import { Text } from "../../components/Forms/InputButton/styles";
import { SightCreditCardConfig } from "../../models/Rates";
import { ArrowIcon } from "../../styles/icons/ArrowIcon";
import { CreditCardIcon } from "../../styles/icons/CreditCardIcon";
import { Rewind } from "../../styles/icons/Rewind";
import { clearMask } from "../../utils";
import { formatPaymentRangeFromApi, formatPaymentRangeToApi } from "../../utils/formatPaymentRangeToApi";
import { formatPercentageToNumber } from "../../utils/formatPercentageToNumber";
import { Divider, Header, Section } from "./styles";

interface SightCreditCardSectionProps extends TaxSectionProps {
  sightCreditCardConfigData: SightCreditCardConfig;
  defaultSightCreditCardConfigData: SightCreditCardConfig;
  sellerPaymentReceiptType?:string;
  splitStatus?: boolean
}

export function SightCreditCardSection({
  editionMode = false,
  sightCreditCardConfigData,
  asModalView,
  sellerPaymentReceiptType,
  defaultSightCreditCardConfigData,
  register,
  errors,
  watch,
  setValue,
  colorFinder,
  splitStatus,
}: SightCreditCardSectionProps) {
  const delayForRedeem = formatTextView("sightCreditCardDelayForRedeem", "delayForRedeem", formatPaymentRangeFromApi);
  const rate = formatTextView("sightCreditCardRate", "rate", formatPercentageToNumber);

  function handleSetDefaultValue(name: string, defaultValue: string, func: any) {
    const convertionFunction = {
      "range": formatPaymentRangeFromApi,
      "percentage": (value) => formatPercentageToNumber(value)
    }
    setValue(name, convertionFunction[func](defaultSightCreditCardConfigData[defaultValue]))
  }
  function formatTextView(auxName: string, innerValue: string, formater: (param: any) => any, formaterAsCurrency?: boolean): JSX.Element {
    const defaultValueFormatted = formaterAsCurrency ? formater({ value: defaultSightCreditCardConfigData[innerValue] }) : formater(defaultSightCreditCardConfigData[innerValue]);
    const pastValue = formaterAsCurrency ? formater({ value: sightCreditCardConfigData[innerValue] }) : formater(sightCreditCardConfigData[innerValue]);
    const laterValue = watch(auxName);
    if (clearMask(pastValue) === clearMask(laterValue)) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {laterValue}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultValueFormatted)}>
            {pastValue}
          </Text>
          <ArrowIcon size={13} />
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultValueFormatted)}>
            {laterValue}
          </Text>
        </Section>
      );
    }
  }
  return (
    <Section flexDir="column">
      <Section gap=".4rem" margin={asModalView ? "1rem 0 0" : ""}>
        <CreditCardIcon />
        <Header>Cartão Recorrente e À vista</Header>
        {splitStatus && (
          <Flex
            align="center"
            px="6px"
            color="#33594D"
            backgroundColor="#c1d3cd"
            borderRadius="4px"
          >
            Split
          </Flex>
        )}
        
      </Section>
      {!asModalView && (
        <Section>
          <InputButton
            label="Tempo de repasse"
            variant="ghost"
            bgColor="#EDF1F7"
            h="27px"
            width={asModalView ? "120px" : ""}
            tooltipButtonText="Redefinir para o valor padão"
            mask="paymentRange"
            name="sightCreditCardDelayForRedeem"
            sellerPaymentReceiptType={sellerPaymentReceiptType}
            register={{ ...register("sightCreditCardDelayForRedeem") }}
            defaultValue={formatPaymentRangeFromApi(watch("sightCreditCardDelayForRedeem"))}
            infoTooltipLabel={sellerPaymentReceiptType ? "Seu método de recebimento não permite edição de tempo de repasse" :""}
            disabled={!editionMode || sellerPaymentReceiptType === "TIMELINE" }
            buttonFunction={() => handleSetDefaultValue("sightCreditCardDelayForRedeem", "delayForRedeem", "range")}
            color={() => colorFinder(formatPaymentRangeToApi(watch("sightCreditCardDelayForRedeem")), defaultSightCreditCardConfigData?.delayForRedeem)}
            buttonDisabled={formatPaymentRangeToApi(watch("sightCreditCardDelayForRedeem")) === defaultSightCreditCardConfigData?.delayForRedeem}
            icon={<Rewind color={formatPaymentRangeToApi(watch("sightCreditCardDelayForRedeem")) === defaultSightCreditCardConfigData?.delayForRedeem ? "#00000040" : "black"} />}
            errors={errors?.sightCreditCardDelayForRedeem}
          />
          <InputButton
            label="Taxa"
            variant="ghost"
            bgColor="#EDF1F7"
            h="27px"
            width={asModalView ? "120px" : ""}
            tooltipButtonText="Redefinir para o valor padão"
            mask="percentageRacional"
            name="sightCreditCardRate"
            register={{ ...register("sightCreditCardRate") }}
            defaultValue={formatPaymentRangeFromApi(watch("sightCreditCardRate"))}
            disabled={!editionMode }
            buttonFunction={() => handleSetDefaultValue("sightCreditCardRate", "rate", "percentage")}
            color={() => colorFinder(formatPercentageToNumber(watch("sightCreditCardRate"), true), defaultSightCreditCardConfigData?.rate)}
            buttonDisabled={formatPercentageToNumber(watch("sightCreditCardRate"), true) === defaultSightCreditCardConfigData?.rate}
            icon={<Rewind color={formatPercentageToNumber(watch("sightCreditCardRate"), true) === defaultSightCreditCardConfigData?.rate ? "#00000040" : "black"} />}
            errors={errors?.sightCreditCardRate}
          />
        </Section>
      )}
      {asModalView && (
        <Section>
          <Section flexDir="column" gap=".1rem">
            <Text fontSize=".8rem" color="var(--gray-400)">
              Tempo de repasse
            </Text>
            {delayForRedeem}
          </Section>
          <Section flexDir="column" gap=".1rem">
            <Text fontSize=".8rem" color="var(--gray-400)">
              Taxa
            </Text>
            {rate}
          </Section>
          <Section>
          </Section>
        </Section>
      )}
      <Divider />
    </Section>
  )
}